import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router';

import {
    ContentTitle,
} from '@src/components/common/Display/titles';

import FeaturedTrainingsAndJobAids from './FeaturedTrainingsAndJobAids';

import '@src/css/global.scss';

/**
 * ## Trainings
 *
 * Training and Job Aids Spotlight Content
 *
 * @param {array} trainings - Trainings Data
 */
export const Trainings = ({ trainings }) => {
    if (!trainings || trainings.length === 0) {
        return null;
    }

    let items = trainings;
    const featuredTrainings = trainings.filter((i) => i.is_featured === true);
    if (featuredTrainings.length > 0) {
        items = featuredTrainings;
    }

    items = items.slice(0, 12);

    return (
        <>
            <Row>
                <Col sm={12}>
                    <ContentTitle
                        title="Featured Training and Job Aids"
                    />
                </Col>
            </Row>
            <FeaturedTrainingsAndJobAids items={items} />
            <Row>
                <Col className="text-center">
                    <Link to="/training-and-job-aids" className="btn btn-primary">
                        View All Trainings and Job Aids
                    </Link>
                </Col>
            </Row>
        </>
    );
};

Trainings.propTypes = {
    trainings: PropTypes.arrayOf(PropTypes.object),
};

export default Trainings;
